import { render, staticRenderFns } from "./VerGeocerca.vue?vue&type=template&id=51f251af"
import script from "./VerGeocerca.vue?vue&type=script&lang=js"
export * from "./VerGeocerca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports